import { configureStore } from '@reduxjs/toolkit';
import reducers from './reducers';

/** Builds the app's Redux store. Used by the app entry point and by tests (renderWithProviders). */
export function createAppStore() {
  return configureStore({
    reducer: reducers,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ immutableCheck: false, serializableCheck: false, actionCreatorCheck: false }),
  });
}

export type AppStore = ReturnType<typeof createAppStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
